import { Form, TextArea } from "semantic-ui-react"

import { MultiLineParagraph } from "components/lib/UI"

const LongText = ({ field, fieldValue = "", updateIdea, isEditing }) => {
  if (!isEditing) return <MultiLineParagraph content={fieldValue} />
  return (
    <Form>
      <TextArea value={fieldValue} onChange={(_e, { value }) => updateIdea(value, ["templated", field.id])} />
    </Form>
  )
}

export default LongText
